/**
 * Combine all sagas in this file and export the rootSaga.
 */

import {all} from 'redux-saga/effects';
import loginSaga from '../pages/login/saga';
import driverSaga from '../pages/driverManagement/saga';
export default function* rootSaga() {
  yield all([
    loginSaga(),
    driverSaga()
  ]);
}
